import { h, Fragment, cn, type VNode } from '../../../lib/vdom.js';
import * as I from './Icon.js';

export default function Tech() {
  return (
    <section id="tech">
      <div className="content">
        <h3 className="section-subheading">EXPERTS IN TECH</h3>
        <h1 className="section-heading">Our Tech Stack</h1>
        <div className="grid">
          <div className="tech-stack-item">
            <I.IconTypeScript />
            <p>TypeScript</p>
          </div>
          <div className="tech-stack-item">
            <I.IconReact />
            <p>React.js</p>
          </div>
          <div className="tech-stack-item">
            <I.IconNode />
            <p>Node.js</p>
          </div>
          <div className="tech-stack-item">
            <I.IconSql />
            <p>PostgreSQL</p>
          </div>
          <div className="tech-stack-item">
            <I.IconNginx />
            <p>Nginx</p>
          </div>
          <div className="tech-stack-item">
            <I.IconLinux />
            <p>Linux</p>
          </div>
        </div>
      </div>
    </section>
  );
}
